(function () {
    'use strict';

    angular.module('ib-validation-module')
        .directive('ibCheckRemoveDniValidator', ibCheckRemoveDniValidator);

    ibCheckRemoveDniValidator.$inject = ['$compile'];
    /* istanbul ignore next */
    function ibCheckRemoveDniValidator($compile) {
        // Usage: <input ng-model="model" ib-check-remove-dni-validator></input>
        //
        // Creates: adds an spanish dni validator to the input
        //
        var directive = {
            restrict: 'A',
            replace: false,
            terminal: true,
            priority: 1000,
            link: link
        };
        return directive;

        function link($scope, $element, $attrs) {
            if($scope.$parent.pasDocsCtrl.pasDocsData.nationality !== 'ES'){
                $element.removeAttr('ib-dni-validator');
                $element.removeAttr('data-ib-dni-validator');
            }
            $element.removeAttr('ib-check-remove-dni-validator'); //remove the attribute to avoid indefinite loop
            $element.removeAttr('data-ib-check-remove-dni-validator'); //also remove the same attribute with data- prefix in case users specify data-common-things in the html

            $compile($element)($scope);
        };
    }
})();